import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Login from './components/auth/Login';
import AppShell from './components/layout/AppShell';

function App() {
  const [token, setToken] = useState(localStorage.getItem('kspro_token'));
  const [user,  setUser]  = useState(() => {
    const id           = localStorage.getItem('kspro_userId');
    const username     = localStorage.getItem('kspro_user');
    const displayName  = localStorage.getItem('kspro_displayName') || '';
    const profileImage = localStorage.getItem('kspro_profileImage') || '';
    const theme        = localStorage.getItem('kspro_theme') || 'dark';
    const fontSize     = localStorage.getItem('kspro_fontSize') || 'normal';
    document.documentElement.setAttribute('data-theme', theme);
    if (fontSize !== 'normal') document.documentElement.setAttribute('data-fontsize', fontSize);
    return id ? { id, username, displayName, profileImage, theme, fontSize } : null;
  });
  const [role, setRole] = useState(localStorage.getItem('kspro_role'));

  useEffect(() => {
    if (token) {
      localStorage.setItem('kspro_token', token);
      axios.defaults.headers.common['x-auth-token'] = token;
    } else {
      localStorage.removeItem('kspro_token');
      localStorage.removeItem('kspro_user');
      localStorage.removeItem('kspro_userId');
      localStorage.removeItem('kspro_role');
      localStorage.removeItem('kspro_displayName');
      localStorage.removeItem('kspro_profileImage');
      localStorage.removeItem('kspro_theme');
      document.documentElement.setAttribute('data-theme', 'dark');
      delete axios.defaults.headers.common['x-auth-token'];
    }
  }, [token]);

  useEffect(() => {
    if (token) axios.defaults.headers.common['x-auth-token'] = token;
  }, []);

  const handleLogin = ({ token, userId, username, role, displayName, profileImage, theme, fontSize, lastProject }) => {
    const resolvedTheme    = theme    || 'dark';
    const resolvedFontSize = fontSize || 'normal';
    // Store before rendering AppShell — its mount effects (socket connect, first API calls)
    // read the token from localStorage and run before the [token] effect above
    localStorage.setItem('kspro_token', token);
    setToken(token);
    setUser({ id: userId, username, displayName: displayName || '', profileImage: profileImage || '', theme: resolvedTheme, fontSize: resolvedFontSize, lastProject: lastProject || null });
    setRole(role);
    document.documentElement.setAttribute('data-theme', resolvedTheme);
    if (resolvedFontSize !== 'normal') document.documentElement.setAttribute('data-fontsize', resolvedFontSize);
    else document.documentElement.removeAttribute('data-fontsize');
    localStorage.setItem('kspro_user',         username);
    localStorage.setItem('kspro_userId',        userId);
    localStorage.setItem('kspro_role',          role);
    localStorage.setItem('kspro_displayName',   displayName   || '');
    localStorage.setItem('kspro_profileImage',  profileImage  || '');
    localStorage.setItem('kspro_theme',         resolvedTheme);
    localStorage.setItem('kspro_fontSize',      resolvedFontSize);
  };

  const handleLogout = () => {
    setToken(null);
    setUser(null);
    setRole(null);
  };

  useEffect(() => {
    window.addEventListener('kspro:unauthorized', handleLogout);
    return () => window.removeEventListener('kspro:unauthorized', handleLogout);
  }, []);

  const handleUserUpdate = (updated) => {
    const next = { ...user, ...updated };
    setUser(next);
    if (updated.displayName  !== undefined) localStorage.setItem('kspro_displayName',  updated.displayName  || '');
    if (updated.profileImage !== undefined) localStorage.setItem('kspro_profileImage', updated.profileImage || '');
    if (updated.theme    !== undefined) {
      localStorage.setItem('kspro_theme', updated.theme);
      document.documentElement.setAttribute('data-theme', updated.theme);
    }
    if (updated.fontSize !== undefined) {
      localStorage.setItem('kspro_fontSize', updated.fontSize);
      if (updated.fontSize !== 'normal') document.documentElement.setAttribute('data-fontsize', updated.fontSize);
      else document.documentElement.removeAttribute('data-fontsize');
    }
  };

  if (!token) return <Login onLogin={handleLogin} />;
  return <AppShell user={user} role={role} onLogout={handleLogout} onUserUpdate={handleUserUpdate} />;
}

export default App;
